/* ============================================
   BBO LANDING — rail, sticky CTA (footer-aware), UTM, smooth-scroll.
   Countdown + progress meter are handled globally by bb-timer.js
   (single 48h source); no timer logic here anymore.
   ============================================ */
(function () {
  'use strict';

  /* ---- winner rail arrows ---- */
  const railTrack = document.getElementById('railTrack');
  if (railTrack) {
    document.querySelectorAll('.rail-arrow').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dir = btn.getAttribute('data-rail-dir');
        const card = railTrack.querySelector('.winner-card');
        const step = card ? card.getBoundingClientRect().width + 14 : 240;
        railTrack.scrollBy({ left: dir === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  }

  /* ---- sticky CTA: show after hero, hide over footer ---- */
  const stickyCta = document.getElementById('stickyCta');
  const hero = document.querySelector('.hero');
  if (stickyCta && hero) {
    let pastHero = false, footerOnScreen = false;
    function applyVisibility() { stickyCta.classList.toggle('visible', pastHero && !footerOnScreen); }
    function checkHero() {
      const past = hero.getBoundingClientRect().bottom < 0;
      if (past !== pastHero) { pastHero = past; applyVisibility(); }
    }
    window.addEventListener('scroll', checkHero, { passive: true });
    checkHero();
    const footerEl =
      document.querySelector('#shopify-section-footer') ||
      document.querySelector('footer.footer') ||
      document.querySelector('.site-footer') ||
      document.querySelector('footer') ||
      document.querySelector('[role="contentinfo"]');
    if (footerEl && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        footerOnScreen = entries[0].isIntersecting;
        applyVisibility();
      }, { threshold: 0 }).observe(footerEl);
    }
  }

  /* ---- UTM propagation ---- */
  (function propagateUTM() {
    const params = window.location.search;
    if (!params) return;
    const incoming = new URLSearchParams(params);
    document.querySelectorAll('[data-propagate-utm]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:')) return;
      try {
        const url = new URL(href, window.location.origin);
        incoming.forEach((value, key) => { if (!url.searchParams.has(key)) url.searchParams.set(key, value); });
        if (!url.searchParams.has('lp_variant')) url.searchParams.set('lp_variant', 'bbo_lpv4v4');
        link.setAttribute('href', url.toString());
      } catch (e) { /* skip malformed */ }
    });
  })();

  /* ---- smooth-scroll for in-page anchors ---- */
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      const id = this.getAttribute('href');
      if (id.length <= 1) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const themeHeader = document.querySelector('#shopify-section-header') || document.querySelector('header.header');
      const offset = (themeHeader ? themeHeader.offsetHeight : 0) + 12;
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });
})();
